import React from 'react';
// ui
import { Typography } from 'rmwc/Typography';

const Footer = () => {
    return (
        <footer className={'footer'}>
            <a href={'https://www.hlf.org.uk/'} target={'_blank'} rel="noopener noreferrer">
                <img src={'./tnl_hlfe_white.png'}
                     style={{ maxWidth: '100%' }}
                     alt={'Heritage lottery fund logo'}/>
            </a>
            <Typography style={{ marginTop: 30, color: '#bbbbbb', borderTop:'1px solid rgba(255,255,255,0.2)', paddingTop:10 }}
                        use={'overline'} tag={'p'}>
                Website developed by <a href="https://chrisdennett.co.uk/" target="_blank"  rel="noopener noreferrer"
                                        style={{ color: '#fff', textDecoration: 'none' }}>chrisdennett.co.uk</a>
            </Typography>
        </footer>
    )
};

export default Footer;


// WEBPACK FOOTER //
// ./src/app/components/Footer.js